const buttonPopupLink = document.querySelector('.timer-form-link')
if (buttonPopupLink) {
    setTimeout(function () {
        if (recordTimerSeconds > 0) {
            buttonPopupLink.click()
        }
    }, 30000)
}

function recordTimerRender(timer) {
    const formTimer = document.querySelector('.js-timer')
    if (formTimer) {
        var day = formTimer.querySelector('.time-number-day')
        var hour = formTimer.querySelector('.time-number-hour')
        var minute = formTimer.querySelector('.time-number-minute')
        var second = formTimer.querySelector('.time-number-second')

        var dayText = formTimer.querySelector('.time-unit-day')
        var hourText = formTimer.querySelector('.time-unit-hour')
        var minuteText = formTimer.querySelector('.time-unit-minute')
        var secondText = formTimer.querySelector('.time-unit-second')

        day.textContent = timer.time.days >= 10 ? timer.time.days : '0' + timer.time.days || '00'
        hour.textContent = timer.time.hours >= 10 ? timer.time.hours : '0' + timer.time.hours || '00'
        minute.textContent = timer.time.minutes >= 10 ? timer.time.minutes : '0' + timer.time.minutes || '00'
        second.textContent = timer.time.seconds >= 10 ? timer.time.seconds : '0' + timer.time.seconds || '00'

        dayText.textContent = timer.dataSet.days || 'дней'
        hourText.textContent = timer.dataSet.hours || 'часов'
        minuteText.textContent = timer.dataSet.minutes || 'минут'
        secondText.textContent = timer.dataSet.seconds || 'секунд'
    }
}

if (typeof recordTimerSeconds !== 'undefined') {
    startTimer(recordTimerSeconds, recordTimerRender)
}
